site.pageImage = {
	init:function() {
		$('label', '#elm_page_galleryImageId .lmnt').each(function() {
			var $this = $(this),
				url = $this.text();
			$this.html($this.html().replace(url, '<img src="'+url+'" />'));
		});
	}
};

site.inits.push('site.pageImage.init()');
